import React, { lazy } from "react";
import { authRoles } from "../../auth/authRoles";

const TenantUsers = lazy(() => import("./TenantUsers"));

const tenantsRoutes = [
  {
    path: "/tenants/users",
    element: <TenantUsers />,
    auth: authRoles.admin,
  },
];

export default tenantsRoutes;
